import UserInfoEdit from '../components/profile/UserInfoEdit';

export default function UpdateProfile() {
  return (
    <>
      <UserInfoEdit />
    </>
  );
}
